module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_fr-c89a753e9944220a74d78ba137b9989b.png";